function runWhenJQueryIsLoadedBuyXGetY(callback) {
    if (window.jQuery) {
        // jQuery is loaded, run the callback
        callback(jQuery);
    } else {
        // jQuery is not loaded, wait for 100ms and try again
        setTimeout(function() {
            runWhenJQueryIsLoadedBuyXGetY(callback);
        }, 100);
    }
}

runWhenJQueryIsLoadedBuyXGetY(function($) {

	console.info("JQUERY_BuyXGetY", jQuery().jquery);
	
	const buyXGetY = function() {
		
		this.file = null;
		this.cart = null;
		this.idVariantCurrentCartList = [];
		window.lastCartItems = [];
		this.currentCartItems = [];

		const toPromotionHandle = (value) => {
			if (typeof value !== 'string') return '';
			let normalised = value.toLowerCase();
			if (normalised.normalize) {
				normalised = normalised.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			}
			return normalised.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
		};

		const ensureArray = (value) => {
			if (Array.isArray(value)) {
				return value.filter(item => item !== null && item !== undefined);
			}
			if (value === undefined || value === null || value === '') return [];
			return [value];
		};

		const ensureNumberArray = (value) => {
			return ensureArray(value).map((item) => {
				const parsed = parseInt(item, 10);
				return Number.isFinite(parsed) ? parsed : null;
			}).filter(item => item !== null);
		};

		const ensureCollectionsArray = (value) => {
			return ensureArray(value).map((entry) => {
				if (entry && typeof entry === 'object') {
					const normalised = Object.assign({}, entry);
					if (!normalised.handle && (normalised.title || normalised.name)) {
						normalised.handle = toPromotionHandle(normalised.title || normalised.name);
					}
					return normalised;
				}
				if (typeof entry === 'string') {
					return {
						title: entry,
						handle: toPromotionHandle(entry)
					};
				}
				return null;
			}).filter(Boolean);
		};

		const normaliseSourcePromotion = (promo = {}) => {
			const id = promo.special_id || promo.id || promo.promo_id || null;
			const normalised = Object.assign({}, promo, {
				special_id: id,
				id,
				buy_variants_ids: ensureNumberArray(promo.buy_variants_ids),
				buy_variants_handles: ensureArray(promo.buy_variants_handles).map(String),
				buy_collections: ensureCollectionsArray(promo.buy_collections),
				buy_quantity: promo.buy_quantity ? parseInt(promo.buy_quantity, 10) || 0 : 0,
				buy_value: promo.buy_value ? parseFloat(promo.buy_value) || 0 : 0,
				get_variants_ids: ensureNumberArray(promo.get_variants_ids),
				get_variants_handles: ensureArray(promo.get_variants_handles).map(String),
				get_variants_prices: ensureArray(promo.get_variants_prices),
				get_variants_qty: ensureNumberArray(promo.get_variants_qty),
				get_quantity: promo.get_quantity ? parseInt(promo.get_quantity, 10) || 1 : 1,
				get_value: promo.get_value ? parseFloat(promo.get_value) || 0 : 0,
				get_percentage: promo.get_percentage ? parseFloat(promo.get_percentage) || 0 : 0,
				title: promo.title || '',
				type: promo.type || '',
				is_auto: promo.is_auto === true || promo.is_auto === 'true'
			});

			if (!normalised.get_variants_qty.length && normalised.get_quantity) {
				normalised.get_variants_qty = normalised.get_variants_ids.map(() => normalised.get_quantity);
			}

			return normalised;
		};

		this.load = function(callback) {
			$.getJSON(hausoftoolsData.buy_x_get_y, (data) => {
				console.info("JQUERY_BuyXGetY", data);
				if(Array.isArray(data) && data.length){
					const normalisedData = data.map(normaliseSourcePromotion);
					this.file = normalisedData;
					if (window.theme && window.theme.cart) {
						window.theme.cart.buy_x_get_y = normalisedData.map(promo => Object.assign({}, promo));
					}
					if(callback) callback(normalisedData);
				}
			});
		}
		this.add_template = function(callback) {
			if(!this.file || this.file.length === 0)	return;
			if(location.pathname.indexOf('/products') !== -1){
				let variantId = parseInt($(".product-single__variants").val());
				console.info("variant_id", variantId);

				this.file.find(o => {
					const parsedVariantId = parseInt(variantId, 10);
					const buyVariantIds = Array.isArray(o.buy_variants_ids) ? o.buy_variants_ids.map(id => parseInt(id, 10)) : [];
					const getVariantHandles = Array.isArray(o.get_variants_handles) ? o.get_variants_handles : [];
					const buyQty = o.buy_quantity || 0;
					const buyValue = o.buy_value || 0;
					const buyCollections = Array.isArray(o.buy_collections) ? o.buy_collections : [];

					if(buyVariantIds.length && buyVariantIds.indexOf(parsedVariantId) !== -1){
						let posBuyItem = buyVariantIds.indexOf(parsedVariantId);
						let getVariantHandle = getVariantHandles[posBuyItem];
						if(!getVariantHandle) return;
						fetch(window.Shopify.routes.root + 'products/'+getVariantHandle+'.js')
						.then(response => response.json())
						.then(product => {
							console.info("productproduct", product);
							$(".product-single__form").after(`<a href="/products/${getVariantHandle}" class="specialPromoItemSection">
								<div class="img" style="background-image: url(${product.media[0].preview_image.src});"></div>
								<div class="info">
									<span>Receive for free <span class="bold">${product.title}</span> when you buy `+(buyQty > 1? buyQty+' unit of ' : '')+`this product.</span>
								</div>
							</a>`);
						});
					}

					let intPromoCheck = setInterval(() => {
						if(typeof meta !== 'object')	return;
						else{
							clearInterval(intPromoCheck);
							if(buyCollections.length){
								const vendorHandle = toPromotionHandle(meta.product.vendor || '');
								buyCollections.forEach(c => {
									const collectionHandle = toPromotionHandle(c.handle || '');
									const collectionTitleHandle = toPromotionHandle(c.title || c.name || '');

									if(collectionHandle === vendorHandle || collectionTitleHandle === vendorHandle){

										let minToOrderMsg = `this product`;
										if(buyQty)
											minToOrderMsg = (buyQty > 1? buyQty+' unit of ' : '')+`this product`;
										if(buyValue)
											minToOrderMsg = `a total of $${buyValue} from ${meta.product.vendor}`;

										getVariantHandles.forEach(getVariantHandle => {
											if(!getVariantHandle) return;
											fetch(window.Shopify.routes.root + 'products/'+getVariantHandle+'.js')
											.then(response => response.json())
											.then(product => {
												console.info("productproduct", product);
												$(".product-single__form").after(`<a href="/products/${getVariantHandle}" class="specialPromoItemSection">
													<div class="img" style="background-image: url(${product.media[0].preview_image.src});"></div>
													<div class="info">
														<span>Receive for free <span class="bold">${product.title}</span> when you buy ${minToOrderMsg}.</span>
													</div>
												</a>`);
											});
										});
									}
								})
							}
						}
					}, 100);
				})
			}
		},
		this.fetchCart = function(callback) {
			$.getJSON(window.Shopify.routes.root + "cart.js", (cart) => {
				console.info("Fetched_cart", cart);
				this.cart = cart;
				this.currentCartItems = this.cart.items.map(o => {
					const parsedId = parseInt(o.variant_id, 10);
					return {
						variant_id: Number.isFinite(parsedId) ? parsedId : null,
						quantity: o.quantity
					}
				})
				if(callback)	callback(cart)
			});
		}
		this.watcher = function(callback) {

			let cycled = 0;
			let watchBuyX = setInterval(() => {
				cycled++
				if(!this.file && cycled > 2){
					clearInterval(watchBuyX);
				}else{
					this.fetchCart(callback)
				}

			}, 5000);
		}
		this.treatment = function(cart, callback) {

			/**
			 * Automatically adds or removes free gifts based on the configured promotions.
			 *
			 * - When the qualifying conditions are met, the highest priced gift that is
			 *   not already present (or not in sufficient quantity) is added to the cart.
			 * - When the conditions are no longer met, any related free gifts are removed.
			 */

			if (cart) {
				this.cart = cart;
			}

			if (!this.cart || !Array.isArray(this.cart.items)) {
				if (callback) callback(null);
				return;
			}

			if (!this.file || !this.file.length) {
				if (callback) callback(null);
				return;
			}

			const toArray = (value) => {
				if (Array.isArray(value)) return value;
				if (value === undefined || value === null || value === '') return [];
				return [value];
			};

			const toLower = (value) => (typeof value === 'string' ? value.toLowerCase() : '');

			const integerFrom = (value) => {
				const parsed = parseInt(value, 10);
				return Number.isFinite(parsed) ? parsed : null;
			};

			const numberFrom = (value) => {
				const parsed = parseFloat(value);
				return Number.isFinite(parsed) ? parsed : null;
			};

			const getItemProperty = (item, key) => {
				if (!item || !item.properties || typeof item.properties !== 'object') return '';
				const value = item.properties[key];
				return value === undefined || value === null ? '' : String(value);
			};

			const isAutomaticGiftItem = (item, promoId) => {
				if (!item) return false;
				if (getItemProperty(item, '_buy_x_get_y') !== 'automatic') return false;

				if (promoId === undefined || promoId === null || promoId === '') {
					return true;
				}

				return getItemProperty(item, '_buy_x_get_y_promo') === String(promoId);
			};

			const normalisePromo = (promo) => {
				if (!promo) return null;

				const buyVariantIds = [];
				toArray(promo.buy_variants_ids || promo.buyVariantsIds).forEach((variantId) => {
					const parsed = integerFrom(variantId);
					if (parsed) buyVariantIds.push(parsed);
				});

				const rawGetVariants = toArray(promo.get_variants_ids || promo.getVariantIdList);
				const rawPrices = toArray(promo.get_variants_prices || promo.getVariantsPrices);
				const rawVariantQuantities = toArray(promo.get_variants_qty || promo.getVariantsQty);
				const defaultFreeQty = integerFrom(promo.get_qty ?? promo.get_quantity) || 1;

				const getVariants = rawGetVariants.reduce((acc, variantId, index) => {
					const parsedId = integerFrom(variantId);
					if (!parsedId) return acc;

					const explicitQty = integerFrom(rawVariantQuantities[index]);
					const quantity = explicitQty && explicitQty > 0 ? explicitQty : defaultFreeQty;
					const price = numberFrom(rawPrices[index]) || 0;

					acc.push({
						id: parsedId,
						quantity: quantity > 0 ? quantity : 1,
						price,
						promoId: promo.id || promo.promo_id || promo.promotion_id || null
					});

					return acc;
				}, []);

				if (!getVariants.length) {
					return null;
				}

				const rawCollections = toArray(promo.buy_collections || promo.buyCollectionObj);
				const collections = rawCollections.reduce((acc, collection) => {
					if (!collection) return acc;
					const title = toLower(collection.title || collection.name);
					const handle = toLower(collection.handle || collection.slug);
					if (title || handle) {
						acc.push({ title, handle });
					}
					return acc;
				}, []);

				const requiredQuantity = integerFrom(promo.buy_qty ?? promo.buy_quantity ?? promo.buyQty) || 0;
				const requiredValueRaw = numberFrom(promo.buy_value ?? promo.buyValue);
				const requiredValue = requiredValueRaw && requiredValueRaw > 0 ? requiredValueRaw : 0;

				return {
					id: promo.id || promo.promo_id || promo.promotion_id || null,
					buyVariantIds,
					getVariants,
					collections,
					requiredQuantity: requiredQuantity > 0 ? requiredQuantity : 0,
					requiredValue
				};
			};

			const getQualifyingMetrics = (promo) => {
				let quantity = 0;
				let value = 0;

				// The free gift(s) must never count toward the qualifying total,
				// otherwise a promo like "spend $50 on Klein Tools" would be
				// satisfied by the free bottle opener itself (the bug that was
				// reported: it looked like "buy $50 of bottle openers to get one").
				const freeVariantIds = promo.getVariants.map((variant) => variant.id);

				const hasBuyVariants = promo.buyVariantIds.length > 0;
				const hasBuyCollections = promo.collections.length > 0;

				// Nothing to qualify against.
				if (!hasBuyVariants && !hasBuyCollections) {
					return { quantity, value };
				}

				this.cart.items.forEach((item) => {
					// Skip anything we auto-added as a gift.
					if (isAutomaticGiftItem(item)) {
						return;
					}

					const variantId = integerFrom(item.variant_id);

					// Never let the gift product count toward the threshold,
					// regardless of whether the promo is variant- or collection-based.
					if (variantId && freeVariantIds.indexOf(variantId) !== -1) {
						return;
					}

					// An item qualifies if it is one of the explicit "buy" variants
					// OR it belongs to one of the "buy" collections/vendors. Using a
					// union (instead of an either/or branch) means a spend-on-collection
					// promo is never hijacked by a stray variant list, and vice versa.
					let qualifies = false;

					if (hasBuyVariants && variantId && promo.buyVariantIds.indexOf(variantId) !== -1) {
						qualifies = true;
					}

					if (!qualifies && hasBuyCollections) {
						const vendorKey = toLower(item.vendor);
						if (vendorKey) {
							qualifies = promo.collections.some((collection) => {
								return (collection.title && collection.title === vendorKey) ||
									(collection.handle && collection.handle === vendorKey);
							});
						}
					}

					if (qualifies) {
						quantity += item.quantity;
						value += (item.price / 100) * item.quantity;
					}
				});

				return { quantity, value };
			};

			const doesPromoQualify = (promo, metrics) => {
				if (!promo.getVariants.length) return false;
				if (!promo.buyVariantIds.length && !promo.collections.length) return false;

				if (promo.requiredQuantity && metrics.quantity < promo.requiredQuantity) {
					return false;
				}

				if (promo.requiredValue && metrics.value < promo.requiredValue) {
					return false;
				}

				if (!promo.requiredQuantity && !promo.requiredValue) {
					return metrics.quantity > 0 || metrics.value > 0;
				}

				return true;
			};

			this.currentCartItems = this.cart.items.map((item) => {
				return {
					variant_id: integerFrom(item.variant_id),
					quantity: item.quantity
				};
			});

			const currentSnapshot = JSON.stringify(this.currentCartItems);
			if (!cart && JSON.stringify(window.lastCartItems) === currentSnapshot) {
				if (callback) callback(null);
				return;
			}

			const promotions = this.file.map(normalisePromo).filter(Boolean);
			if (!promotions.length) {
				if (callback) callback(null);
				return;
			}

			const addCandidates = [];
			const removeMap = {};

			promotions.forEach((promo) => {
				const metrics = getQualifyingMetrics(promo);
				const qualifies = doesPromoQualify(promo, metrics);

				promo.getVariants.forEach((freeVariant) => {
					const variantId = freeVariant.id;
					if (!variantId) return;

					const matchingGiftItems = this.cart.items.filter((item) => {
						return integerFrom(item.variant_id) === variantId && isAutomaticGiftItem(item, promo.id);
					});
					const existingQty = matchingGiftItems.reduce((total, item) => total + item.quantity, 0);
					const requiredQty = freeVariant.quantity && freeVariant.quantity > 0 ? freeVariant.quantity : 1;

					if (qualifies) {
						const shortfall = requiredQty - existingQty;
						if (shortfall > 0) {
							addCandidates.push({
								variantId,
								quantity: shortfall,
								price: freeVariant.price || 0,
								promoId: promo.id
							});
						}
					} else if (existingQty > 0) {
						matchingGiftItems.forEach((item) => {
							if (item.key) {
								removeMap[item.key] = 0;
							}
						});
					}
				});
			});

			const dedupedAdds = {};
			addCandidates.forEach((candidate) => {
				const key = candidate.variantId;
				if (!dedupedAdds[key]) {
					dedupedAdds[key] = Object.assign({}, candidate);
				} else {
					dedupedAdds[key].quantity += candidate.quantity;
					dedupedAdds[key].price = Math.max(dedupedAdds[key].price, candidate.price);
				}
			});

			const itemsToAdd = Object.values(dedupedAdds);
			itemsToAdd.sort((a, b) => b.price - a.price);

			const fetchPromises = [];

			if (itemsToAdd.length) {
				const bestFreebie = itemsToAdd[0];
				if (bestFreebie.quantity > 0) {
					fetchPromises.push(fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							items: [{
								id: bestFreebie.variantId,
								quantity: bestFreebie.quantity,
								properties: {
									'_buy_x_get_y': 'automatic',
									'_buy_x_get_y_promo': bestFreebie.promoId || ''
								}
							}]
						})
					}).then((response) => response.json()).catch((error) => {
						console.error('Error:', error);
					}));
				}
			}

			if (Object.keys(removeMap).length) {
				fetchPromises.push(fetch(window.Shopify.routes.root + 'cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ updates: removeMap })
				}).then((response) => response.json()).catch((error) => {
					console.error('Error:', error);
				}));
			}

			const finalize = (result) => {
				window.lastCartItems = this.currentCartItems;
				if (typeof document !== 'undefined') {
					document.dispatchEvent(new CustomEvent('cart:updated', {
						detail: {
							cart: this.cart
						}
					}));
				}
				if (callback) callback(result);
			};

			if (fetchPromises.length) {
				Promise.all(fetchPromises)
					.then((res) => finalize(res))
					.catch((error) => {
						console.error('Error:', error);
						finalize(null);
					});
			} else {
				finalize(null);
			}
		}
	};

	try {
		let buyGet = new buyXGetY();
		window.buyGet = buyGet;
		buyGet.load(() => {
			buyGet.add_template();
			buyGet.fetchCart((cart) => {
				buyGet.treatment(cart);
			});
		});
	} catch (error) {
		console.error("Error:", error);
	}
});
